"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var AccountBalance_1 = __importDefault(require("../data-providers/AccountBalance"));

var Assets_1 = __importDefault(require("../data-providers/Assets"));

var classes = require('./AssetSelector.module.css');

var AssetElement = function AssetElement(_a) {
  var asset = _a.asset;
  return react_1.default.createElement("div", {
    className: classes.assetElement
  }, react_1.default.createElement("div", {
    className: classes.assetName
  }, asset.name), react_1.default.createElement(AccountBalance_1.default, {
    asset: asset,
    render: function render(err, data) {
      return data && react_1.default.createElement("div", {
        className: classes.assetBalance
      }, data.usdBalance ? "$" + data.usdBalance : data.displayBalance);
    }
  }));
};

var AssetSelector = function AssetSelector(_a) {
  var selected = _a.selected,
      assets = _a.assets,
      onChange = _a.onChange,
      disabled = _a.disabled,
      network = _a.network;

  var _b = react_1.useState(false),
      isOpen = _b[0],
      setOpen = _b[1];

  react_1.useEffect(function () {
    var clickListener = function clickListener() {
      return setOpen(false);
    };

    document.addEventListener('click', clickListener);
    return function () {
      return document.removeEventListener('click', clickListener);
    };
  });

  var Dropdown = function Dropdown(assets) {
    if (!selected) {
      onChange(assets[0]);
    }

    var selectedAsset = assets.filter(function (asset) {
      return asset === selected;
    })[0];
    return react_1.default.createElement("div", {
      className: classes.selectContainer
    }, react_1.default.createElement("div", {
      onClick: function onClick() {
        return setOpen(!isOpen);
      },
      className: classes.selectBox
    }, selectedAsset && react_1.default.createElement(AssetElement, {
      asset: selectedAsset
    })), isOpen && !disabled && react_1.default.createElement("div", {
      className: classes.selectDropdown
    }, assets.filter(function (asset) {
      return !network || asset.network === network;
    }).map(function (asset) {
      return react_1.default.createElement("div", {
        key: asset.id,
        className: classes.dropdownItem,
        onClick: function onClick() {
          setOpen(false);
          onChange(asset);
        }
      }, react_1.default.createElement(AssetElement, {
        asset: asset
      }));
    })));
  };

  return assets ? Dropdown(assets) : react_1.default.createElement(Assets_1.default, {
    render: Dropdown
  });
};

exports.default = AssetSelector;